<container>
  <div id="pdfTable" #pdfTable>
    <page-intro-header title="{{ 'SUBJECTS.TITLE' | translate }}">
      <button  mat-flat-button color="primary" routerLink="/new-subject"
        *ngIf="this.object.origin !== 'entrance' && !isMainCenterBelgrade && !isUserDrugostepeni && !isCpsuUser && !isAssociate">
        {{ 'SUBJECTS.NEW_SUBJECT' | translate }}
      </button>
    </page-intro-header>
    <mat-card class="card" style="align-content: center;">
      <card-header title="{{ 'SUBJECTS.CARD_TITLE' | translate }}">
        <div class="card__aside">
          <mat-form-field appearance="outline" class="search centar-search"
            *ngIf="isMainCenterBelgrade || isUserDrugostepeni">
            <mat-label> {{'GLOBAL.CENTER' | translate}} </mat-label>
            <input type="text" matInput [formControl]="subcenter" [matAutocomplete]="autoSubcenter" />
            <mat-autocomplete panelWidth="auto" #autoSubcenter="matAutocomplete" [displayWith]="displayCustomFormat"
              (optionSelected)="changeCenter($event.option.value)">
              <mat-option *ngFor="let cent of filteredSubcenters | async" [value]="cent">
                {{ cent.name }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <mat-form-field appearance="outline" class="search">
            <mat-label>{{ 'GLOBAL.SEARCH' | translate }}</mat-label>
            <input matInput type="text" [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="add($event)"
              placeholder="{{'GLOBAL.SEARCH' | translate}}">
          </mat-form-field>
          <button mat-icon-button class="button-square button-square--large button-export" color="primary"
            [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger" [matBadge]="'*'" [matBadgeHidden]="!filterInUse"
            matTooltip="{{ 'SUBJECT_DOCUMENTS.TOOLTIP_FILTER' | translate }}">
            <mat-icon class="button-square__icon">filter_list</mat-icon>
          </button>
          <mat-menu #menu="matMenu" class="filter-menu">
            <form [formGroup]="filterForm" class="filter-menu__content" (click)="$event.stopPropagation()">
              <field-holder> <mat-form-field appearance="outline">
                  <mat-label> {{'GLOBAL.SUBJECT.STATUS' | translate}} </mat-label>
                  <mat-select formControlName="status" [compareWith]="compareLoadedObjects">
                    <mat-option *ngFor="let status of statusOptions" [value]="status.value">
                      {{ status.viewValue}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </field-holder>
              <field-holder>
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'GLOBAL.SEARCH_ADRESS' | translate }}</mat-label>
                  <input matInput type="text" [matChipInputFor]="chipList" formControlName="address"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    placeholder="{{'GLOBAL.SEARCH_ADRESS' | translate}}">
                </mat-form-field>
              </field-holder>
              <field-holder *ngIf="isServiceProviderUser"> 
                <mat-form-field appearance="outline">
                  <mat-label> {{'SERVICE_PROVIDERS.CREATE.LICENCE.PROVIDED_SERVICE' | translate}} </mat-label>
                  <mat-select formControlName="providedServices" [compareWith]="compareLoadedObjects">
                    <mat-option></mat-option>
                    <mat-option *ngFor="let providedService of providedServices" [value]="providedService">
                      {{ providedService.title}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </field-holder>
              <form-footer>
                <button class="form-footer__button form-footer__button--secondary" mat-stroked-button color="primary"
                  type="button" (click)="resetFilter()">
                  {{ 'SUBJECT_DOCUMENTS.FILTER.RESET' | translate }}
                </button>
                <button class="form-footer__button form-footer__button--primary" mat-flat-button color="primary"
                  type="button" (click)="applyCustomFilter()">
                  {{ 'SUBJECT_DOCUMENTS.FILTER.APPLY' | translate }}
                </button>
              </form-footer>
            </form>
          </mat-menu>
          <button mat-button color="primary" (click)="exportCsv()"
            class="button-square button-square--large button-export">
            <icon-file-csv matTooltip="{{ 'CSV' | translate }}" class="button-square__icon" size="24"></icon-file-csv>
          </button>
          <button mat-button color="primary" (click)="printPDF()"
            class="button-square button-square--large button-export">

            <icon-file-pdf matTooltip="{{ 'PDF' | translate }}" class="button-square__icon" size="24"></icon-file-pdf>
          </button>
        </div>
      </card-header>
      <mat-chip-list #chipList class="chip-list" [ngStyle]="{ 'display': searchItems.length > 0 ? 'block' : 'none' }">
        <mat-chip *ngFor="let item of searchItems" [selectable]="selectable" [removable]="removable"
          (removed)="remove(item)">
          {{item.name}}
          <mat-icon matChipRemove *ngIf="removable">
            cancel
          </mat-icon>
        </mat-chip>
      </mat-chip-list>
      <app-registry *ngIf="!isCpsuUser && !isCpsuCenter && !isServiceProviderUser" [object]="object"
        (loadingCompleted)="loadingChangeStatus($event)" (emitPageData)="pageDataChanged($event)"
        [getNextPageEvent]="getNextPageEvent" [getPreviousPageEvent]="getPreviousPageEvent"
        [getFirstPageEvent]="getFirstPageEvent" [getLastPageEvent]="getLastPageEvent"
        [getPageInNewSizeEvent]="getPageInNewSizeEvent" [applyFilterEvent]="applyFilterEvent"
        [changeCenterEvent]="changeCenterEvent" (rowClickedEvent)="rowClickedEvent($event)"
        (handleOpenDialogEvent)="handleOpenDialog($event)" [customFilterFormValue]="filterForm.value"
        [filterInUse]="filterInUse"></app-registry>
      <app-cpsu-registry *ngIf="isCpsuUser || isCpsuCenter" [object]="object"
        (loadingCompleted)="loadingChangeStatus($event)" (emitPageData)="pageDataChanged($event)"
        [getNextPageEvent]="getNextPageEvent" [getPreviousPageEvent]="getPreviousPageEvent"
        [getFirstPageEvent]="getFirstPageEvent" [getLastPageEvent]="getLastPageEvent"
        [getPageInNewSizeEvent]="getPageInNewSizeEvent" [applyFilterEvent]="applyFilterEvent"
        [changeCenterEvent]="changeCenterEvent" (rowClickedEvent)="rowClickedEvent($event)"
        (handleOpenDialogEvent)="handleOpenDialog($event)" [customFilterFormValue]="filterForm.value"
        [filterInUse]="filterInUse"></app-cpsu-registry>
      <app-service-providers-registry *ngIf="isServiceProviderUser" [object]="object"
        (loadingCompleted)="loadingChangeStatus($event)" (emitPageData)="pageDataChanged($event)"
        [getNextPageEvent]="getNextPageEvent" [getPreviousPageEvent]="getPreviousPageEvent"
        [getFirstPageEvent]="getFirstPageEvent" [getLastPageEvent]="getLastPageEvent"
        [getPageInNewSizeEvent]="getPageInNewSizeEvent" [applyFilterEvent]="applyFilterEvent"
        [changeCenterEvent]="changeCenterEvent" (rowClickedEvent)="rowClickedEvent($event)"
        (handleOpenDialogEvent)="handleOpenDialog($event)" [customFilterFormValue]="filterForm.value"
        [filterInUse]="filterInUse"></app-service-providers-registry>
      <div class="paginator-wrapper" *ngIf="areLoaded">
        <app-custom-pagination [page]="page" (firstPageEvent)="getFirstPage()" (previousPageEvent)="getPreviousPage()"
          (nextPageEvent)="getNextPage()" (lastPageEvent)="getLastPage()" (pageSizeEvent)="getPageInNewSize($event)">
        </app-custom-pagination>
      </div>
      <mat-progress-spinner *ngIf="!areLoaded" color="primary" mode="indeterminate">
      </mat-progress-spinner>
    </mat-card>
  </div>
</container>